import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_icon = _resolveComponent("v-list-item-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, {
      "no-gutters": "",
      class: "pt-1"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "5" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field_filled, {
              modelValue: _ctx.learningModule.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.learningModule.name) = $event)),
              label: "Nom",
              outlined: "",
              class: "pr-1",
              density: "compact",
              "hide-details": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "3" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_select_filled, {
              modelValue: _ctx.learningModule.status,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.learningModule.status) = $event)),
              label: "Statut",
              class: "pr-1",
              items: _ctx.statusOptions,
              "item-text": "text",
              "item-value": "value",
              "item-title": (item) => item.text,
              density: "compact",
              outlined: ""
            }, null, 8, ["modelValue", "items", "item-title"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "2" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field_filled, {
              modelValue: _ctx.learningModule.difficulty,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.learningModule.difficulty) = $event)),
              modelModifiers: { number: true },
              label: "Niveau de difficulté",
              outlined: "",
              class: "pr-1",
              density: "compact",
              "hide-details": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "2" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_select_filled, {
              modelValue: _ctx.learningModule.profileType,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.learningModule.profileType) = $event)),
              label: "Type de profil",
              items: _ctx.profileTypes,
              density: "compact",
              outlined: ""
            }, null, 8, ["modelValue", "items"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field_filled, {
              modelValue: _ctx.learningModule.description,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.learningModule.description) = $event)),
              label: "Description",
              outlined: "",
              density: "compact",
              "hide-details": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "11" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_select_filled, {
              modelValue: _ctx.selectedLearningObject,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedLearningObject) = $event)),
              items: _ctx.availableLearningObjects,
              "item-title": "name",
              "item-value": "id",
              label: "Sélectionner un objet d'apprentissage",
              density: "compact",
              outlined: "",
              clearable: ""
            }, null, 8, ["modelValue", "items"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "1" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn_icon, {
              color: "primary",
              dense: "",
              icon: "$add",
              rounded: "xl",
              class: "d-flex align-center justify-center elevation-0",
              onClick: _ctx.addLearningObject
            }, null, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_list, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.learningModule.learningObjects, (learningObject, index) => {
                  return (_openBlock(), _createBlock(_component_v_list_item, {
                    key: index,
                    class: "mb-2",
                    rounded: "xl",
                    lines: "two",
                    border: ""
                  }, {
                    append: _withCtx(() => [
                      _createVNode(_component_v_btn_icon, {
                        icon: "$fa-minus",
                        onClick: ($event: any) => (_ctx.removeLearningObject(index))
                      }, null, 8, ["onClick"])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[7] || (_cache[7] = [
                              _createTextVNode("$fa-photo-video")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(learningObject.name), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field_filled, {
              modelValue: _ctx.learningModule.key,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.learningModule.key) = $event)),
              label: "Clé unique ( vide pour générer automatiquement )",
              outlined: "",
              density: "compact",
              "hide-details": "",
              readonly: !!_ctx.learningModuleId
            }, null, 8, ["modelValue", "readonly"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          class: "d-flex justify-end"
        }, {
          default: _withCtx(() => [
            (_ctx.learningModuleId)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  class: "ml-2 mr-0 elevation-0",
                  color: "primary",
                  dark: "",
                  rounded: "",
                  dense: "",
                  outlined: "",
                  onClick: _ctx.deleteLearningModule
                }, {
                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                    _createTextVNode(" Supprimer ")
                  ])),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_component_v_btn, {
              class: "ml-2 mr-0 elevation-0",
              color: "primary",
              dark: "",
              rounded: "",
              dense: "",
              disabled: _ctx.isSaveDisabled,
              onClick: _ctx.upsertTutorialsModule
            }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createTextVNode(" Valider ")
              ])),
              _: 1
            }, 8, ["disabled", "onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}